module.exports = __webpack_public_path__ + "static/media/iniesta.a65bfa40.webp";